module.exports = __webpack_public_path__ + "img/51_37.f81730f6.png";